var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-schedule-table',{attrs:{"title":_vm.$t('global.models.schedule.heading'),"subtitle":_vm.$t('global.models.schedule.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }